import { Grid, Box } from '@mui/material'
import { useState, useEffect } from 'react'
import "./showcase.scss"

export default function Showcase(props: any) {
    const { media } = props;
    // const [failed, setFailed] = useState(false);
    const [isLoaded, setLoading] = useState(false);

    const imagefailed = () => {
        // setFailed(true);
    }

    useEffect(() => {
        setTimeout(() => {
            setLoading(true);
        }, 1000);
    }, [])

    const imgContainer = (src: string) => {
        return (
            (isLoaded)  ?  (
                <Box className={"ui-border--r12 ui-width--full" + (isLoaded ? "" : "box-15")}>
                    <img src={src} onError={() => imagefailed()} className="ui-image ui-image--fill ui-card--elevated ui-border--r12" alt="" />
                </Box>
            ) : (
                    <Box className={"ui-card--elevated ui-border--r12 ui-width--full " + (isLoaded ? "" : "skeleton-box box-15")}></Box>

            )
        )
    }


    return (
        <>
            <div className="ui-padding--12 "></div>
            <Grid container spacing={6}>
                <Grid item sm={8} xs={12}>
                        {imgContainer(media[0])}
                </Grid>
                <Grid item sm={4} xs={12}>
                        {imgContainer(media[1])}
                        <Box p={1}></Box>
                        {imgContainer(media[2])}
                </Grid>
            </Grid>
            <div className="ui-padding--16"></div>
            <Grid container spacing={6}>
                <Grid item sm={6}>
                        {imgContainer(media[3])}
                </Grid>

                <Grid item sm={6}>
                        {imgContainer(media[4])}
                </Grid>
            </Grid>
        </>
    )
}
